import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css';

const Contact = () => {
  const form = useRef();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs.sendForm('service_wqsc7yb', 'template_26chqef', form.current, 'tkpmNEnFa0rPf8kzj')
      .then(() => {
        setSent(true);
        setSending(false);
        e.target.reset();
        setTimeout(() => setSent(false), 4000);
      })
      .catch(() => {
        setSending(false);
        alert('Something went wrong. Please try again.');
      });
  };

  const contactInfo = [
    {
      icon: 'bx bx-mail-send',
      title: 'Email',
      data: 'hvsharma2164@gmail.com',
      link: 'mailto:hvsharma2164@gmail.com',
      action: 'Send Email',
    },
    {
      icon: 'bx bxl-whatsapp',
      title: 'WhatsApp',
      data: '+91 70671 33966',
      link: 'https://api.whatsapp.com/send?phone=7067133966&text=Hello, more information!',
      action: 'Message Me',
    },
    {
      icon: 'bx bxl-instagram',
      title: 'Instagram',
      data: '@hvs_harshvardhan21',
      link: 'https://ig.me/m/hvs_harshvardhan21',
      action: 'DM Me',
    },
  ];

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="section__header reveal">
          <span className="section__label">Contact</span>
          <h2 className="section__title">Get in Touch</h2>
          <p className="section__subtitle">Let's build something amazing together</p>
        </div>

        <div className="contact__content">
          <div className="contact__info reveal-left">
            <h3 className="contact__info-title">Let's talk about your project</h3>
            <p className="contact__info-description">
              Feel free to reach out for collaborations, opportunities, or just a friendly hello. I'm always excited to connect with fellow tech enthusiasts.
            </p>

            <div className="contact__cards">
              {contactInfo.map((info, index) => (
                <a 
                  href={info.link}
                  key={index}
                  className="contact__card"
                  target={info.title !== 'Email' ? '_blank' : undefined}
                  rel={info.title !== 'Email' ? 'noopener noreferrer' : undefined}
                >
                  <div className="contact__card-icon">
                    <i className={info.icon}></i>
                  </div>
                  <div className="contact__card-content">
                    <h4 className="contact__card-title">{info.title}</h4>
                    <span className="contact__card-data">{info.data}</span>
                  </div>
                  <i className="bx bx-right-arrow-alt contact__card-arrow"></i>
                </a>
              ))}
            </div>
          </div>

          <div className="contact__form-wrapper reveal-right">
            <form ref={form} onSubmit={sendEmail} className="contact__form">
              <div className="contact__form-group">
                <label htmlFor="contact-name" className="contact__form-label">Name</label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  className="contact__form-input"
                  placeholder="Your full name"
                  required
                />
              </div>

              <div className="contact__form-group">
                <label htmlFor="contact-email" className="contact__form-label">Email</label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  className="contact__form-input"
                  placeholder="your@email.com"
                  required
                />
              </div>

              <div className="contact__form-group">
                <label htmlFor="contact-project" className="contact__form-label">Message</label>
                <textarea
                  id="contact-project"
                  name="project"
                  className="contact__form-input contact__form-textarea"
                  placeholder="Tell me about your project..."
                  rows="5"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className={`btn btn--primary contact__submit ${sent ? 'contact__submit--sent' : ''}`}
                disabled={sending}
                id="contact-submit-btn"
              >
                {sending ? (
                  <>
                    <span className="contact__spinner"></span>
                    <span>Sending...</span>
                  </>
                ) : sent ? (
                  <>
                    <i className="bx bx-check"></i>
                    <span>Message Sent!</span>
                  </>
                ) : (
                  <>
                    <span>Send Message</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352Z" fill="currentColor" />
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;